import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class WorkFlow extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            innerStatus: 0,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        var p1 = this.httpPost("api/v1/workflow/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                }
            });
        Promise.all([p1]).then(r => {
            this.setState({
                loading: false
            })
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/workflow/save", {
            id: this.state.id,
            title: this.state.data.record.title,
            type: this.state.data.record.type,
            steps: this.state.data.record.steps,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.innerStatus = data.innerStatus;
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getBlankStep() {
        return {
            id: this.uuidv4(),
            title: '',
            step: this.state.data.record.steps.length + 1,
            userGroups: []
        };
    }
    addNewStep() {
        var v = this.getBlankStep();
        this.state.data.record.steps.push(v);
        this.setState({ data: this.state.data });
    }
    removeStep(id) {
        var t = [];
        this.state.data.record.steps.forEach((i) => {
            if (i.id != id) {
                t.push(i);
            }
        });
        this.state.data.record.steps = t;
        this.setState({ data: this.state.data });
    }
    setItemValue(f, e, id) {
        this.state.data.record.steps.forEach((i) => {
            if (i.id === id) {
                i[f] = e;
            }
        });
        this.setState({ data: this.state.data });
    }
    renderStepBox(item) {
        return <div className="row mr-10 acc-pay-get-box" style={{ "background-color": "#337AB7", "border": "1px solid #337AB7", "position": "relative" }} >
            <div className="col-sm-1 text-center" style={{ "min-height": "58px", "display": "table" }}>
            </div>
            <div className="col-sm-11 pd-10" style={{ "background-color": "white", "color": "rgb(34, 34, 34)" }} >
                <div className="row p-1" style={{ "margin-left": "5px" }}>
                    <div className="col-sm-2">گام:
                        <input defaultValue={item.step} onChange={e => this.setItemValue('step', parseInt(e.target.value), item.id)} autocomplete="off" type="text" className="price col-sm-3 form-control input-sm" />
                    </div>
                    <div className="col-sm-10">
                        عنوان:
                        <input defaultValue={item.title} onChange={e => this.setItemValue('title', e.target.value, item.id)} autocomplete="off" type="text" className="description col-sm-11 form-control input-sm" />
                    </div>
                    <div className="col-sm-12">
                        گروه کاربران مجاز:
                        <SelectAsync
                            value={item.userGroups}
                            isMulti={true}
                            placeholder="جستجو و انتخاب گروه های کاربری"
                            defaultOptions
                            loadOptions={(inputValue, callback) => this.loadUserGroupsOptions(inputValue, callback)}
                            onChange={e => this.setItemValue('userGroups', e, item.id)}
                        />
                    </div>
                </div>
            </div>
            <a onClick={e => this.removeStep(item.id)} className="hand" style={{ "width": "10px", "height": "20px", "position": "absolute", "color": "#3379b6", "left": "0", "cursor": "pointer", "top": "0" }}>x</a>
        </div>
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات شعبه" : "افزودن شعبه جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-9">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان:</label>
                                            <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">نوع:</label>
                                            <select disabled={this.state.data.record.id !== this.getDefaultGuid()} defaultValue={this.state.data.record.type} onChange={e => this.state.data.record.type = parseInt(e.target.value)} autocomplete="off" className="form-control input-sm">
                                                <option value="0">انتخاب</option>
                                                <option value="1">فاکتور خرید داخلی</option>
                                                <option value="2">فاکتور فروش</option>
                                                <option value="3">فاکتور برگشت از خرید</option>
                                                <option value="4">فاکتور برگشت از فروش</option>
                                                <option value="5">فاکتور ضایعات</option>
                                                <option value="6">فاکتور خرید خارجی</option>
                                                <option value="7">فاکتور خرید خدمات</option>
                                                <option value="8">فاکتور فروش خدمات</option>
                                                <option value="9">دریافتی</option>
                                                <option value="10">پرداختی</option>
                                                <option value="11">دفتر دریافت</option>
                                                <option value="12">انتقال وجه</option>
                                                <option value="13">رسید خرید</option>
                                                <option value="14">حواله فروش</option>
                                                <option value="15">حواله برگشت از خرید</option>
                                                <option value="16">رسید برگشت از فروش</option>
                                                <option value="17">رسید مانده ابتدای دوره  </option>
                                                <option value="18">حواله مصرف</option>
                                                <option value="19">رسید تولید</option>
                                                <option value="20">جابجایی بین انبار</option>
                                                <option value="21">رسید ضایعات</option>
                                                <option value="22">رسید اضافات</option>
                                                <option value="23">حواله کسورات</option>
                                                <option value="24">امانی رسید</option>
                                                <option value="25">امانی حواله</option>
                                                <option value="26">خرید خارجی رسید</option>
                                                <option value="27">خرید ملزومات رسید</option>
                                                <option value="28">دارایی ثابت رسید</option>
                                                <option value="29">سفارش فروش</option>
                                                <option value="30">پیش فاکتور</option>
                                                <option value="31">سفارش تولید</option>
                                                <option value="32">سفارش خرید</option>
                                                <option value="33">آنالیز و برآورد سفارش</option>
                                                <option value="34">پردازش تولید</option>
                                                <option value="35">سفارش خرید خارجی</option>
                                                <option value="36">اسناد حسابداری دستی</option>
                                                <option value="37">اسناد حسابداری فاکتور فروش</option>
                                                <option value="38">اسناد حسابداری فاکتور خرید</option>
                                                <option value="39">اسناد حسابداری حواله خروج</option>
                                                <option value="40">اسناد حسابداری رسید ورود</option>
                                                <option value="41">اسناد حسابداری برگشت از فروش</option>
                                                <option value="42">اسناد حسابداری برگشت از خرید</option>
                                                <option value="43">اسناد حسابداری دریافت</option>
                                                <option value="44">اسناد حسابداری پرداخت</option>
                                                <option value="45">اسناد حسابداری مدیریت تنخواه</option>
                                                <option value="46">اسناد حسابداری فاکتور ضایعات</option>
                                                <option value="47">اسناد حسابداری قراردادهای فروش اقساطی</option>
                                                <option value="48">اسناد حسابداری صورتحساب واحد ساختمانی</option>
                                                <option value="49">اسناد حسابداری چکها</option>
                                                <option value="50">اسناد حسابداری انتقال وجه</option>
                                                <option value="51">اسناد حسابداری انبارگردانی</option>
                                                <option value="52">تولید محصولی/مرحله ای</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {this.state.data.record.steps.map(m => this.renderStepBox(m))}
                                <div className="row mt-4">
                                    <div className="col-sm-12">
                                        <div className="btn-group" role="group">
                                            <button type="button" className="btn btn-primary btn-sm hand" onClick={e => this.addNewStep()}>
                                                افزودن مرحله جدید
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}